import React, { useEffect, useState } from "react";
import { Spin, Button, Row, Col, Input, Space, Card, Typography } from "antd";
import { ArrowRight, Dumbbell, Search } from "lucide-react";
import { FONT } from "constants/index";
import { notificationErroInternal } from "util/api-utils";
import { ColumnsUser } from "./columns-table";
import DrawerApp from "components/drawer-app";
import FormNewUserControl from "./load-control-drawer-new-control";
import {
  getUsersControl,
  getUsersControlBoot,
} from "services/control/control-service";
import FormLoadUserComparation from "./load-control-drawer-comparation";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth, listMinWidth } from "util/responsive";
import ResponsiveDataList from "components/responsive-data-list";

const { Text } = Typography;

const LoadControlListClient = ({ isBoot = false }) => {
  const { isMobile } = useBreakpoint();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(null);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openComparation, setOpenComparation] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  function getData() {
    let obj = { search: search };
    if (search == null || search == "") {
      obj = {};
    }

    const fetchFn = isBoot ? getUsersControlBoot : getUsersControl;
    fetchFn(obj)
      .then((res) => {
        res = res.map((obj) => ({
          ...obj,
          comparation: comparation,
          edit: edit,
        }));
        setLoading(false);
        setData(res);
      })
      .catch(() => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const onClose = () => {
    setEditId(null);
    setOpen(false);
    refreshData();
  };

  const onCloseComparation = () => {
    setEditId(null);
    setOpenComparation(false);
    refreshData();
  };

  function edit(row) {
    setEditId(row.id);
    setOpen(true);
  }

  function comparation(row) {
    setEditId(row.id);
    setOpenComparation(true);
  }

  const selectedUser = data.find((item) => item.id == editId);

  const mountFilter = () => (
    <Row
      className="reviews-filter-row"
      gutter={[16, 16]}
      style={{ padding: "10px", alignItems: "center" }}
    >
      <Col xs={24} md={12} lg={10}>
        <Input
          allowClear
          value={search ?? ""}
          placeholder="Pesquisar Aluno"
          onChange={(e) => setSearch(e.target.value)}
          prefix={<Search size={18} color="#e0e0e0" />}
          style={{ width: "100%" }}
          onPressEnter={refreshData}
        />
      </Col>
      <Col xs={24} md={6} lg={4}>
        <Button
          style={{ fontFamily: FONT, width: "100%" }}
          type="primary"
          icon={
            <ArrowRight
              size={18}
              style={{ marginBottom: "-3px", marginRight: "7px" }}
            />
          }
          onClick={refreshData}
        >
          Filtrar
        </Button>
      </Col>
    </Row>
  );

  return (
    <div className="container-load-client">
      <Spin size="large" spinning={loading}>
        {mountFilter()}
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 500px",
              minWidth: listMinWidth(isMobile),
            }}
          >
            <Card
              id="card-table"
              className="card-table-list"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Dumbbell
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Controle dos Alunos
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <ResponsiveDataList
                isMobile={isMobile}
                forceCardLayout
                cardVariant="profile"
                rowKey="id"
                columns={ColumnsUser(isBoot)}
                dataSource={data}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: "Sem registro",
                }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Registrar Controle"}
        body={
          <FormNewUserControl
            user={selectedUser}
            isBoot={isBoot}
            onClose={onClose}
          />
        }
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 60)}
      />
      <DrawerApp
        open={openComparation}
        onClose={onCloseComparation}
        title={"Histórico"}
        body={<FormLoadUserComparation userId={editId} isBoot={isBoot} />}
        size={"large"}
        width={drawerWidth(isMobile, 90)}
        isOnlyView={true}
      />
    </div>
  );
};

export default LoadControlListClient;
